import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/big-rentz-lifts')({
  component: RouteComponent,
  staticData: {
    authorization: { permission: { lift: ['read'] } },
  },
});

function RouteComponent() {
  return <Outlet />;
}
